export default "__VITE_ASSET__0G_3Zegf__"